@if (!isShowVerifyBox) {
<div class="auth-page-container">
  @if (!showPasswordFields && !isError || showMessage) {
  <h2 mat-dialog-title class="join-header">
    <div class="j-header-content">
      <section class="flex-row-gap align-item-center">
        <img src="../../../../../assets/images/oe-logo-full.png" alt="logo">
        <span>{{'joinEarn' | translate : { bonusAmount: joiningBonus } }}</span>
      </section>

      <button class="btn float-end mt-2 form-close-btn" (click)="closeDialog()">
        <svg width="25" height="23" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.4 15L10 11.4L13.6 15L15 13.6L11.4 10L15 6.4L13.6 5L10 8.6L6.4 5L5 6.4L8.6 10L5 13.6L6.4 15ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
            fill="#BAB5B5" />
        </svg>
      </button>
    </div>
  </h2>
  }
  @if (!showMessage) {
    @if (showPasswordFields && !isError) {
  <h2 mat-dialog-title class="join-header pb-0 px-5"><span class="jn-text">{{'welcomeboard' | translate}}, {{firstName}}! {{'choosePassword' | translate}}</span>
    <span class="Joinclose-btn" (click)="closeDialog()">
      <svg width="25" height="23" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.4 15L10 11.4L13.6 15L15 13.6L11.4 10L15 6.4L13.6 5L10 8.6L6.4 5L5 6.4L8.6 10L5 13.6L6.4 15ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
          fill="#BAB5B5" />
      </svg>
    </span>
  </h2>
  <div class="d-flex justify-content-between align-items-center px-4">
    <p class="text-danger fs-7 px-4 m-0 font-laila-regular fs-6 fw-bold">{{userEmail}}</p>
    <div> <button class="btn form-close-btn">
        <a class="go-back-btn" (click)="goBack()">{{'goBack' | translate}}</a>
      </button></div>
  </div>
  }
  }
  <mat-divider></mat-divider>
  <mat-dialog-content class="mat-typography join-box-body" [ngClass]="{'error-box-center': showMessage}">
    @if (!isShowloader) {
      @if (!showMessage) {
    <form class="join-form-box" [formGroup]="joinForm" (ngSubmit)="onSubmitJoinForm()" autocomplete="false">
      <div class="registration-form">

        @if (!showPasswordFields) {
        <section>

          <!-- Name Container -->
          <div class="row">
            <section class="col-md-6 col-sm-12">
              <div class="form-group mb-2">
                <label for="exampleFormControlInput1" class="form-label">{{'firstName' | translate}}</label>
                <section>
                  <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('firstName')}">
                    <span class="input-group-text" id="basic-addon1">
                      <mat-icon>type_specimen</mat-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'typeHere' | translate"
                      formControlName="firstName" aria-label="Username" aria-describedby="basic-addon1">
                  </div>
                </section>
              </div>
            </section>
            <section class="col-md-6 col-sm-12">
              <div class="form-group mb-2">
                <label for="exampleFormControlInput1" class="form-label">{{'lastName' | translate}}</label>
                <section>
                  <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('lastName')}">
                    <span class="input-group-text" id="basic-addon1">
                      <mat-icon>type_specimen</mat-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'typeHere' | translate"
                      formControlName="lastName" aria-label="Username" aria-describedby="basic-addon1">
                  </div>
                </section>
              </div>

            </section>
          </div>

          <div class="row">
            <div class="form-group mb-2">
              <label for="exampleFormControlInput1" class="form-label">{{'emailAddress' | translate}}</label>
              <section>
                <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('email')}">
                  <span class="input-group-text" id="basic-addon1">
                    <mat-icon>mark_email_read</mat-icon>
                  </span>
                  <input type="text" class="form-control" [placeholder]="'typeHere' | translate" formControlName="email"
                    aria-label="Username" aria-describedby="basic-addon1">
                </div>
              </section>
            </div>
          </div>


          <!-- zip and Language Container -->
          <div class="row">
            <section class="col-md-6 col-sm-12">
              <div class="form-group mb-2">
                <label for="exampleFormControlInput1" class="form-label">{{'birthMonth' |translate}}</label>
                <section>
                  <div class="input-group" [ngClass]="{ 'border-danger': isFieldInvalid('getMonth') }">
                    <span class="input-group-text" id="basic-addon1">
                      <mat-icon>calendar_month</mat-icon>
                    </span>
                    <select class="form-select" aria-label="Default select example" formControlName="getMonth">
                      <option value="" selected>{{'select' | translate}}</option>
                      @for (month of getMonths(); track $index) {
                      <option [value]="$index+1">{{month}}</option>
                      }
                    </select>
                  </div>
                </section>
              </div>
            </section>
            <section class="col-md-6 col-sm-12">
              <div class="form-group mb-2">
                <label for="exampleFormControlInput1" class="form-label">{{'birthYear' |translate}}</label>
                <section>
                  <div class="input-group" [ngClass]="{ 'border-danger': isFieldInvalid('getYear') }">
                    <span class="input-group-text" id="basic-addon1">
                      <mat-icon>cake</mat-icon>
                    </span>
                    <select class="form-select" aria-label="Default select example" formControlName="getYear">
                      <option value="" selected>{{'select' | translate}}</option>
                      @for (years of getYears(); track $index) {
                      <option [value]="years">{{years}}</option>
                      }
                    </select>
                  </div>
                </section>
              </div>
            </section>
          </div>

          <!-- Hear opinion Edge -->
          @if(opinionEdgeHearOption){
          <div class="row">
            <div class="form-group mb-2">
              <label for="exampleFormControlInput1" class="form-label">{{'hearOpinionEdge' | translate}}</label>
              <section>
                <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('opinionEdgeHear')}">
                  <span class="input-group-text" id="basic-addon1">
                    <mat-icon>add_moderator</mat-icon>
                  </span>
                  <select class="form-select" aria-label="Default select example" formControlName="opinionEdgeHear">
                    <option value="" selected>{{'select' | translate}}</option>
                    @for (item of opinionEdgeHearOption; track $index) {
                    <option [value]="item.optionStatement">{{item.optionStatement}}</option>
                    }
                  </select>
                </div>
              </section>
            </div>
          </div>
          }



          <!-- gender and DOB -->
          <div class="row">
            <section class="col-md-6 col-sm-12">
              <div class="form-group mb-2">
                <label for="exampleFormControlInput1" class="form-label">{{'gender' | translate}}</label>
                <section>
                  <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('gender')}">
                    <span class="input-group-text" id="basic-addon1">
                      <mat-icon>person</mat-icon>
                    </span>
                    <select class="form-select" aria-label="Default select example" formControlName="gender">
                      <option value="" selected>{{'select' | translate}}</option>
                      @for (item of gender?.option; track $index) {
                      <option [value]="item.optionStatement">{{item.optionStatement}}</option>
                      }
                    </select>
                  </div>
                </section>
              </div>
            </section>
            <section class="col-md-6 col-sm-12">
              <div class="form-group mb-2">
                <label for="exampleFormControlInput1" class="form-label">{{'pincode' | translate}}</label>
                <section>
                  <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('zipCode')}">
                    <span class="input-group-text" id="basic-addon1">
                      <mat-icon>type_specimen</mat-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'typeHere' | translate"
                      formControlName="zipCode" aria-label="zipCode" aria-describedby="basic-addon1">
                  </div>
                </section>
              </div>
            </section>


          </div>


        </section>
        }

        <!-- Password Fields and Final Submit Button -->
        @if (showPasswordFields) {
        <!-- password and confirmPassword -->
        <section class="row">
          <section class="col-md-12 col-sm-12">
            <div class="form-group mb-3">
              <label for="password" class="form-label">{{'password' | translate}}</label>
              <section class="position-relative">
                <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('password')}">
                  <span class="input-group-text" id="basic-addon1">
                    <mat-icon>password</mat-icon>
                  </span>
                  <input (focus)="showCriteria = true" (blur)="showCriteria = false"
                    [type]="isShowPassword? 'text': 'password'" class="form-control px-3"
                    [placeholder]="'typeHere' | translate" aria-label="password" aria-describedby="basic-addon1"
                    formControlName="password">
                  <span class="input-group-text cursor-pointer" (click)="openPassword()"
                    *ngIf="isShowPassword"><mat-icon>remove_red_eye</mat-icon></span>
                  <span class="input-group-text cursor-pointer" (click)="openPassword()" *ngIf="!isShowPassword">
                    <mat-icon>visibility_off</mat-icon></span>
                </div>
                @if (showCriteria) {
                <div class="password-criteria">
                  <ul class="p-0 fs-9 text-secondary mb-0">
                    <li
                      [ngClass]="{'text-success success-password':passwordStrength?.hasLetter, 'text-danger error-password': !passwordStrength?.hasLetter}">
                      {{'containLetter'| translate}}</li>
                    <li
                      [ngClass]="{'text-success success-password': passwordStrength?.hasNumber, 'text-danger error-password': !passwordStrength?.hasNumber}">
                      {{'containNumber'| translate}}</li>
                    <li
                      [ngClass]="{'text-success success-password': passwordStrength?.hasSpecialChar, 'text-danger error-password': !passwordStrength?.hasSpecialChar}">
                      {{'containCharacter'| translate}}</li>
                    <li
                      [ngClass]="{'text-success success-password': passwordStrength?.hasMinLength, 'text-danger error-password': !passwordStrength?.hasMinLength}">
                      {{'contain8Characters'| translate}}</li>
                    <li *ngIf="passwordStrength?.hasSpace"
                      [ngClass]="{'text-success success-password': !passwordStrength?.hasSpace, 'text-danger error-password': passwordStrength?.hasSpace}">
                      {{'noSpace'| translate}}</li>
                  </ul>
                </div>
                }
              </section>
            </div>
          </section>
          <section class="col-md-12 col-sm-12">
            <div class="form-group mb-3">
              <label for="confirmPassword" class="form-label">{{'confirmPassword' |translate}}</label>
              <section>
                <div class="input-group" [ngClass]="{'border-danger': isFieldInvalid('confirmPassword')}">
                  <span class="input-group-text" id="basic-addon1">
                    <mat-icon>password</mat-icon>
                  </span>
                  <input [type]="showConfirm? 'text': 'password'" class="form-control px-3"
                    [placeholder]="'typeHere' | translate" formControlName="confirmPassword"
                    aria-label="confirmPassword" aria-describedby="basic-addon1">
                  <span class="input-group-text cursor-pointer" (click)="openConfirmPassword()"
                    *ngIf="showConfirm"><mat-icon>remove_red_eye</mat-icon></span>
                  <span class="input-group-text cursor-pointer" (click)="openConfirmPassword()" *ngIf="!showConfirm">
                    <mat-icon>visibility_off</mat-icon></span>
                </div>
              </section>
            </div>
          </section>
          <section class="col-md-12 col-sm-12">
            <div class="form-group mb-2 border p-2 rounded">
              <small>{{'earnBonusPoints' | translate}}</small>
              <section>
                <div class="input-group"
                  [ngClass]="{ 'border-danger bg-red': isFieldInvalid('promoCode') || isBlankPromo || isPromoInvalid, 'success-validation': isPromoSuccess && !isPromoInvalid }">
                  <span class="input-group-text" id="basic-addon1">
                    <svg height="25" width="23" version="1.1" viewBox="0 0 512 512" fill="#000000">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path style="fill:#df9090;"
                          d="M415.272,52.495H293.808c-14.079,0-27.582,5.593-37.538,15.549L13.479,310.837 c-6.911,6.91-6.911,18.115,0,25.025l162.667,162.667c6.911,6.911,18.115,6.911,25.025,0l242.791-242.792 c9.956-9.955,15.549-23.458,15.549-37.538V96.735C459.512,72.303,439.705,52.495,415.272,52.495z M407.497,142.049 c-10.366,10.366-27.173,10.366-37.538,0c-10.366-10.366-10.366-27.172,0-37.538s27.173-10.366,37.538,0 C417.863,114.877,417.864,131.682,407.497,142.049z">
                        </path>
                        <path style="fill:#e8abab;"
                          d="M40.036,337.394L282.827,94.602c9.956-9.955,23.459-15.549,37.538-15.549h121.463 c5.262,0,10.238,1.077,14.92,2.763c-6.142-17.054-22.306-29.32-41.477-29.32H293.808c-14.079,0-27.582,5.593-37.538,15.549 L13.479,310.837c-6.911,6.91-6.911,18.115,0,25.025l26.557,26.557C33.124,355.509,33.124,344.304,40.036,337.394z">
                        </path>
                        <path
                          d="M512,34.88c0.039-9.349-3.569-18.126-10.159-24.716c-6.589-6.589-15.384-10.193-24.716-10.159 c-9.322,0.039-18.098,3.702-24.711,10.314c-2.8,2.8-7.893,8.848-10.679,12.205c-2.926,3.525-2.442,8.755,1.083,11.68 c3.524,2.926,8.754,2.442,11.68-1.083c4.364-5.256,7.971-9.395,9.646-11.071c3.498-3.497,8.132-5.435,13.05-5.456 c0.027,0,0.052,0,0.079,0c4.862,0,9.419,1.88,12.837,5.299c3.437,3.437,5.32,8.024,5.299,12.916 c-0.021,4.917-1.959,9.551-5.456,13.05c-3.131,3.131-13.893,11.668-29.312,22.439c-9.121-15.594-26.037-26.099-45.37-26.099H293.808 c-16.396,0-31.81,6.385-43.405,17.978L7.613,304.971C2.704,309.88,0,316.407,0,323.349c0,6.942,2.704,13.47,7.613,18.378 l162.667,162.667c5.068,5.067,11.722,7.6,18.378,7.6c6.656,0,13.312-2.534,18.378-7.6l242.792-242.791 c11.593-11.594,17.978-27.008,17.978-43.405V96.735c0-3.585-0.363-7.085-1.051-10.47c17.551-12.077,30.435-22.18,34.929-26.674 C508.298,52.979,511.961,44.203,512,34.88z M451.217,96.735v121.463c0,11.965-4.66,23.214-13.119,31.673L195.306,492.664 c-3.664,3.665-9.63,3.665-13.295,0L19.344,329.997c-1.775-1.775-2.754-4.136-2.754-6.648c0-2.512,0.978-4.872,2.754-6.647 L262.135,73.911c8.461-8.46,19.709-13.119,31.673-13.119h121.463c13.64,0,25.53,7.637,31.618,18.859 c-9.798,6.488-20.769,13.387-32.408,20.171c-0.363-0.398-0.734-0.792-1.119-1.177c-13.584-13.584-35.686-13.584-49.27,0 s-13.584,35.686,0,49.27c6.792,6.792,15.714,10.187,24.635,10.187s17.843-3.395,24.635-10.187 c9.067-9.067,12.072-21.926,9.036-33.517c10.123-5.893,19.844-11.916,28.815-17.743C451.215,96.682,451.217,96.709,451.217,96.735z M381.319,127.007c1.457,2.897,4.381,4.569,7.417,4.569c1.253,0,2.526-0.285,3.722-0.887c4.862-2.446,9.707-4.99,14.504-7.596 c0.048,4.735-1.722,9.485-5.328,13.09c-7.116,7.115-18.692,7.115-25.808,0c-7.115-7.116-7.115-18.692,0-25.808 c3.558-3.558,8.231-5.336,12.904-5.336c3.7,0,7.389,1.134,10.536,3.363c-4.695,2.552-9.46,5.051-14.263,7.468 C380.908,117.928,379.259,122.915,381.319,127.007z">
                        </path>
                        <path
                          d="M247.162,168.962c-4.581,0-8.295,3.713-8.295,8.295v175.179c0,4.581,3.714,8.295,8.295,8.295 c4.581,0,8.295-3.714,8.295-8.295V177.257C255.457,172.674,251.743,168.962,247.162,168.962z">
                        </path>
                        <path
                          d="M159.963,240.212c-13.584,13.584-13.584,35.686,0,49.27c6.793,6.793,15.713,10.188,24.635,10.187 c8.92,0,17.843-3.397,24.634-10.187c6.581-6.581,10.205-15.329,10.205-24.635c0-9.306-3.624-18.054-10.205-24.634 C195.648,226.627,173.545,226.628,159.963,240.212z M197.501,277.75c-7.116,7.116-18.692,7.115-25.807,0 c-7.115-7.116-7.115-18.692,0-25.808c3.558-3.558,8.231-5.336,12.904-5.336c4.673,0,9.346,1.778,12.904,5.336l0,0 c3.447,3.447,5.345,8.029,5.345,12.904C202.846,269.721,200.948,274.303,197.501,277.75z">
                        </path>
                        <path
                          d="M285.092,240.212c-13.584,13.584-13.584,35.686,0,49.27c6.792,6.792,15.713,10.187,24.635,10.187 c8.921,0,17.843-3.395,24.634-10.187c13.584-13.584,13.584-35.686,0-49.27C320.777,226.627,298.673,226.628,285.092,240.212z M322.629,277.75c-7.116,7.116-18.692,7.115-25.807,0c-7.115-7.116-7.115-18.692,0-25.808c3.558-3.558,8.231-5.336,12.904-5.336 s9.346,1.778,12.904,5.336C329.745,259.058,329.745,270.634,322.629,277.75z">
                        </path>
                      </g>
                    </svg>
                  </span>
                  <input type="text" class="form-control" [placeholder]="'refferalCode' | translate"
                    formControlName="promoCode" aria-label="refferalCode" id="ref_code_input"
                    autocomplete="one-time-code" maxlength="10" (input)="handleInput($event)">

                  <span class="input-group-text">
                    <!-- Main container that switches between "not validating" and "validating" -->
                    <ng-container *ngIf="!isValidate; else validatingButton">

                      <!--  Success: Show check_circle icon -->
                      <ng-container *ngIf="isPromoSuccess && !isPromoInvalid">
                        <span class="fw-bold mx-1 text-success">${{promoAmount}} {{'earned' | translate}}!</span>
                        <mat-icon color="primary">check_circle</mat-icon>
                      </ng-container>

                      <ng-container *ngIf="isPromoInvalid">
                        <mat-icon color="warn" class="text-danger">cancel</mat-icon>
                      </ng-container>

                      <!-- Default case: Neither success nor failure yet, show Validate button -->
                      <ng-container *ngIf="!isPromoSuccess && !isPromoInvalid">
                        <!-- Default case: show validate button -->
                        <button class="pass-valBtn btn-sm" type="button" [disabled]="isValidate"
                          (click)="validatePromo()">
                          <span role="status">
                            {{ 'apply' | translate }}
                          </span>
                        </button>
                      </ng-container>

                    </ng-container>

                    <ng-template #validatingButton>
                      <button class="pass-valBtn btn-sm" type="button" disabled>
                        <span role="status">
                          {{ 'appling' | translate }}
                        </span>
                      </button>
                    </ng-template>
                  </span>
                </div>
              </section>
            </div>
          </section>
        </section>

        <section class="captcha-container col-md-12 mt-2 px-2" id="login-box">
          <!-- <ngx-recaptcha2 #captchaComponent [siteKey]="recaptchaSiteKey" [size]="'normal'" [theme]="'light'" [hl]="cultureLanguage"
            (success)="handleSuccess($event)" (error)="handleError()" (expire)="handleExpired()" formControlName="reCaptcha">
          </ngx-recaptcha2> -->
          <app-turnstile
              formControlName="reCaptcha"
              #turnstile
              (verified)="onVerified($event)"
              (expired)="onExpired()"
              (errored)="onExpired()"
          ></app-turnstile>
        </section>
        
        <section class="row">
          <div class="col-md-12">
            <section class="form-check">
              <input class="form-check-input" type="checkbox" id="chkDefault" formControlName="acceptTerms">
              <label class="form-check-label" for="chkDefault">
                {{'readMessage' |translate}}
                <a target="_blank" routerLink="/privacy-policy/terms-conditions"
                  class="privacy-anchor">{{'termsConditions'
                  |translate}}</a>
                {{'inThe' |translate}} <a target="_blank" routerLink="/privacy-policy"
                  class="privacy-anchor mx-1">{{'privacyPolicy'
                  |translate}}</a>
              </label>
            </section>
          </div>
        </section>
        }

        <!-- Proceed Button to Show Password Fields -->
        @if (!showPasswordFields) {
        <div class="form-action mt-3">
          <button mat-stroked-button type="button" class="proceed-button form-control"
            (click)="onProceedClick()">{{'next' | translate}}</button>
        </div>
        }

        @if (showPasswordFields) {
        @if (!isLoading) {
        <div class="form-action mt-1">
          <button type="submit" mat-stroked-button class="proceed-button form-control">{{'submit' | translate}}</button>
        </div>
        }
        @if (isLoading) {
        <section class="form-action mt-1">
          <button class="proceed-button form-control" type="button" disabled>
            <span class="spinner-border spinner-border-sm mx-2" aria-hidden="true"></span>
            <span role="status">{{'loading' | translate}}</span>
          </button>
        </section>
        }
        }
        <!-- <div class="social-login">
          <h6 class="text-center">or</h6>
          <div class="social-icons">
            <section class="h-s-sign">
               <div id="googleSignInDiv"></div>
            </section>
           
          </div>
        </div> -->
      </div>
    </form>
    }

    @if (showMessage) {
    <section class="my-profile-questions form-success-card w-100 px-3">
      <img src="../../../../assets/images/success_bg.png" alt="">
      <div class="success-message w-100">
        <h3 class="fs-5">{{showMessage}}</h3>
      </div>
    </section>
    }
    }

    @if (isShowloader) {
    <section class="join-form-box">
      <div class="registration-form">
        <div class="my-profile-questions form-success-card w-100 px-3 position-absolute center-box">
          <img src="../../../../assets/images/success_bg.png" alt="">
          <div class="success-message w-100">
            <div class="loader">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    }
  </mat-dialog-content>
</div>
}

@if (isShowVerifyBox) {
<div class="auth-page-container">
  <h2 mat-dialog-title class="join-header">
    <div class="j-header-content">
      <section class="flex-row-gap align-item-center">
        <img src="../../../../../assets/images/oe-logo-full.png" alt="logo">
        <span>{{'verifyFailedText2' | translate}}</span>
      </section>

      <button class="btn float-end mt-2 form-close-btn" (click)="closeDialog()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.4 15L10 11.4L13.6 15L15 13.6L11.4 10L15 6.4L13.6 5L10 8.6L6.4 5L5 6.4L8.6 10L5 13.6L6.4 15ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
            fill="#BAB5B5" />
        </svg>
      </button>
    </div>
  </h2>
  <mat-divider></mat-divider>
  <mat-dialog-content class="mat-typography join-box-body">
    {{'verifySent' | translate}}
  </mat-dialog-content>
</div>
}